import { render } from "./MachinesForSaleView.vue?vue&type=template&id=6f971e51&scoped=true"
import script from "./MachinesForSaleView.vue?vue&type=script&lang=js"
export * from "./MachinesForSaleView.vue?vue&type=script&lang=js"

import "./MachinesForSaleView.vue?vue&type=style&index=0&id=6f971e51&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f971e51"]])

export default __exports__